var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightMenubarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4905 4.625H2.50915C1.63767 4.625 0.924805 5.21506 0.924805 5.93612V8.86388C0.924805 9.58492 1.63767 10.175 2.50915 10.175H34.4905C35.3618 10.175 36.0748 9.58494 36.0748 8.86388V5.93612C36.0748 5.21508 35.3618 4.625 34.4905 4.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4905 14.8H2.50915C1.63767 14.8 0.924805 15.3901 0.924805 16.1112V19.0389C0.924805 19.7601 1.63767 20.35 2.50915 20.35H34.4905C35.3618 20.35 36.0748 19.7601 36.0748 19.0389V16.1112C36.0748 15.3901 35.3618 14.8 34.4905 14.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4905 25.8999H2.50915C1.63767 25.8999 0.924805 26.49 0.924805 27.2111V30.1388C0.924805 30.86 1.63767 31.4499 2.50915 31.4499H34.4905C35.3618 31.4499 36.0748 30.86 36.0748 30.1388V27.2111C36.0748 26.49 35.3618 25.8999 34.4905 25.8999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMenubarIcon);
export default __webpack_public_path__ + "static/media/lightMenubarIcon.c5621abf4dee8c005ddffc7ec5ae295b.svg";
export { ForwardRef as ReactComponent };